export const setJwtToken = (token, refreshToken) => {
    localStorage.setItem('token', token);
    localStorage.setItem('refresh_token', refreshToken);
};

export const cleanJwtToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
};